var template = require('./index.html');
/**
 * directives.slider Module
 *
 * Description
 */
var app = angular.module('directives.search');
app.directive('search', [function() {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            categories: '=',
            loc: '=',
            hh: '=',
            hhid: '='
        },
        template: require('./index.html'),
        controller: [
            '$scope',
            '$timeout',
            'PortalApi',
            'Services',
            '$state',
            'Locations',
            function ($scope, $timeout, PortalApi, Services, $state, Locations) {
                $scope.services = [];
                var Search = {
                    categories: 0,
                    search:'',
                    init:function () {
                        var data = {
                            query: '',
                            category: 0,
                            sortByPayments: 0
                        };

                        data.location = Locations.location.id;
                        // this 2nd req in start page
                        // PortalApi.searchServices(data)
                        //     .then(function(response) {
                        //         $scope.services = response;
                        //         if(response.length < 12){
                        //             $scope.services_new = false;
                        //         }else{
                        //             $scope.services_new = true;
                        //         }
                        //         $scope.preLoader = false;
                        //     });
                    },
                    toService:function (serviceId, furl) {
                        var data = {
                            serviceId: serviceId,
                            url: serviceId,
                            fields: [],
                            amount: 0,
                            autoCheck: false,
                            // hhTemplate: $scope.hh || false,
                            hhTemplate: false,
                            hh: {
                                templateId: $scope.hhid || null
                            }
                        };

                        if (furl) {
                          data.url = furl;
                        }
                            $scope.preLoader = true;
                            $state.go('pages.payment', data);

                    },
                    find:function (query) {

                        var data = {
                            query: query,
                            category: 0,
                            sortByPayments: 0

                        };
                        if($scope.loc && ($scope.loc !== 1)){
                            data['id'] = $scope.loc.id;
                        }
                        off = 12;
                        if (data.query.length > 0) {
                            $scope.preLoader = true;
                            PortalApi.searchServices(data)
                                .then(function(response) {
                                    $scope.services = response;
                                    if(response.length < 12){
                                        $scope.services_new = false;
                                    }else{
                                        $scope.services_new = true;
                                    }
                                    $scope.preLoader = false;
                                })
                        };
                    },
                    showTopServices: function(){
                        $timeout(function () {
                            PortalApi.searchServices({queryString: Search.search}).then(function (data){
                                var result = [];
                                data.forEach(function (value, key) {
                                    if (typeof(value) == 'object' && parseInt(key) >= 0) {
                                        result.push(value);
                                    }
                                });
                                Services.setData(result);
                                $scope.result = result;
                            });
                        });
                    },
                    keyWatch: function (event) {
                        for (var i = 0; i < event.which.length; i++) {
                          if (!(event.which[i] == 13 || event.which[i] == 38 || event.which[i] == 40)) {
                            return;
                          }
                        }
                        var setActive = function () {
                            if (
                                Search.activeItem > Search.searchResult.length ||
                                Search.activeItem > Search.resultLimit
                            ) {
                                Search.activeItem = 0;
                            } else if (Search.activeItem < 0) {
                                Search.activeItem = Search.searchResult.length > Search.resultLimit ?
                                    Search.resultLimit : Search.searchResult.length - 1;
                            }
                        };
                        switch (event.which) {
                            case 13:
                                if (Search.activeItem !== 0) {
                                    Search.selectService(Search.searchResult[Search.activeItem - 1]);
                                } else {
                                    Search.setSearchResult();
                                    Search.goToSearch();
                                }

                                break;
                            case 38:
                                Search.activeItem--;
                                setActive();
                                break;
                            case 40:
                                Search.activeItem++;
                                setActive();
                                break;
                        }
                    }
                };

                Search.init();
                $scope.Search = Search;
            }
        ]
    }
}]);

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/search/directive.js
 ** module id = 217
 ** module chunks = 1
 **/